import React from 'react';
import { Select } from '@windmill/react-ui';

const SelectVia = ({
	register,
	name,
	label,
	readOnly,
	title,
	onChange,
	required,
	defaultValue,
}) => {
	return (
		<>
			<Select
				className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
				name={name}
				{...register(`${name}`, {
					...(required && { required: `${label} is required!` }),
				})}
				disabled={readOnly}
				onChange={onChange}
				value={defaultValue}
			>
				<option value="" hidden>
					Select {title}
				</option>

				{title === 'Service' ? (
					<>
						<option value="Airport">Airport</option>
						<option value="Other service">Other Service</option>
					</>
				) : (
					<>
						<option value="Flight">Flight</option>
						<option value="Bus">Bus</option>
						<option value="Train">Train</option>
						<option value="Residency">Residency</option>
					</>
				)}
			</Select>
		</>
	);
};

export default SelectVia;
